module.exports = __webpack_public_path__ + "img/emptyImg.6b401ade.png";